module.exports = __webpack_public_path__ + "img/latvia.a1451f8c.png";